import { PackSettings } from '../types/packSettings';
import { boolHttp, http } from './http';
import { GetPackSettingsUrl, PutPackSettingsUrl } from './urls';

const PackSettingsService = {
  getAll: async (): Promise<PackSettings[]> => {
    const req = new Request(GetPackSettingsUrl(), { method: 'GET' });

    let start = 1;
    return await http<PackSettings[]>(req).then((rst) => {
      return rst.map((r) => {
        const item = { ...r, start: start };
        start = item.end + 1;
        return item;
      });
    });
  },

  sync: async (level: PackSettings[]): Promise<boolean> => {
    const req = new Request(PutPackSettingsUrl(), {
      method: 'PUT',
      body: JSON.stringify(level),
    });

    return await boolHttp(req);
  },
};

export default PackSettingsService;
